import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const EditOrgLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "EditOrgLinks" */
      './EditOrgLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
